import GreenhouseStrategy from './GreenhouseStrategy';

export default GreenhouseStrategy;
